/* eslint-disable max-len */
import { FC } from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const CropImageModalHeaderIcon: FC<CommonIconProps> = ({ className }) => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M21.6663 18.9999H24.333V8.33325C24.333 6.86659 23.133 5.66659 21.6663 5.66659H10.9997V8.33325H21.6663V18.9999ZM8.33301 21.6666V0.333252H5.66634V5.66659H0.333008V8.33325H5.66634V21.6666C5.66634 23.1333 6.86634 24.3333 8.33301 24.3333H21.6663V29.6666H24.333V24.3333H29.6663V21.6666H8.33301Z"
      fill="#272756"
    />
  </svg>
);
